module.exports = __webpack_public_path__ + "img/advert_template3.90064afe.png";